<div class="app-container">
  <page-header [icon]="'far-shopping-cart'" [title]="'purchase-order-list'">
    <ng-container class="header-button">
      <btn
        *ngIf="canCreate"
        [routerLink]="['/purchase-order-fork']"
        [label]="'purchaseOrders.btn.createNew'"
        [title]="'purchaseOrders.btn.createNew' | translate"
        [classes]="['btn-first', 'float-right']"
        [icon]="'far-plus'"
        data-cy="create-purchase-order"
      ></btn>
      <modal-export-create
        *ngIf="hasRoleExportProductsForMetrics"
        class="float-right mr-2"
        [suppliers]="suppliers"
        [depots]="depots"
        [entity]="'products'"
        data-cy="create-export"
      ></modal-export-create>
    </ng-container>
  </page-header>

  <section *ngIf="!userHavePermissionForThisPage" class="content max-width-80">
    <loading-spinner [isLoading]="loading"></loading-spinner>
    {{ 'purchasePrice.textForUsersWithoutPermission' | translate }}
  </section>

  <section class="content" *ngIf="userHavePermissionForThisPage">
    <app-filter-form
      [isExportButtonShown]="false"
      [filters]="queryFilters"
      [entity]="'purchaseOrder'"
      [filterVisible]="filters.expanded"
      [isFilterInvisible]="true"
      (onSubmit)="filter()"
      (onClearClick)="clearFilters()"
      (onExportResult)="filter()"
      (filterVisibleChange)="filters.expanded = $event"
    >
      <div class="container-fluid pl-0 pr-0">
        <!--      FIRST ROW OF INPUTS-->
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <form-row-input
              [label]="'purchaseOrders.filter.fulltext'"
              [icon]="null"
              [(model)]="filters.fulltext"
              (keyup.enter)="filter()"
              data-cy="order-name-filter"
            ></form-row-input>
          </div>
          <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
            <div class="row">
              <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
                <form-row-input
                  [label]="'dateCreated.from'"
                  [icon]="null"
                  [inputType]="'date'"
                  [(model)]="filters.dateCreatedFrom"
                ></form-row-input>
              </div>
              <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
                <form-row-input
                  [label]="'dateCreated.to'"
                  [icon]="null"
                  [inputType]="'date'"
                  [(model)]="filters.dateCreatedTo"
                ></form-row-input>
              </div>
              <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
                <form-row-select
                  [label]="'purchaseOrder.filters.suppliers'"
                  [icon]="null"
                  [(model)]="filters.supplier"
                  [options]="suppliers"
                  [bindToObject]="true"
                  data-cy="order-process-filter"
                ></form-row-select>
              </div>
              <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
                <form-row-select
                  [label]="'purchaseOrder.filters.status'"
                  [options]="statusOptions"
                  [(ngModel)]="filters.status"
                ></form-row-select>
              </div>
              <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
                <form-row-select
                  [label]="'purchaseOrder.filters.showFulfilled'"
                  [options]="[
                    { id: false, name: 'no' },
                    { id: true, name: 'yes' },
                  ]"
                  [(ngModel)]="filters.showFulfilledOnly"
                ></form-row-select>
              </div>
              <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                <form-row-select
                  [label]="'purchaseOrder.filters.depotTo'"
                  [icon]="null"
                  [(model)]="filters.depot"
                  [options]="depots"
                  [bindToObject]="true"
                  data-cy="order-process-filter"
                ></form-row-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-filter-form>
    <app-base-listing
      #baseListingComponent
      [storageKey]="storageKey"
      [loadingNextItems]="loading"
      [loadingItems]="reloading"
      [items]="purchaseOrders"
      [columns]="listingColumns"
      [totalItems]="totalItems"
      [currentPage]="currentPage"
      [endPage]="endPage"
      [(sortProp)]="filters.sortProp"
      [(sortDir)]="filters.sortDir"
      [listName]="'purchaseOrders'"
      (reloadList)="filter()"
      (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
      (callAction)="callAction($event)"
    ></app-base-listing>
  </section>
</div>
